<template>
  <div :style="avatarStyle" class="letter-avatar">
    <span>{{ letter }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 40 },
  rounded: { type: Boolean, default: true },
});

const letter = computed(() =>
  props.name ? props.name.charAt(0).toUpperCase() : "X",
);
const backgroundColor = computed(() => {
  // Simple hash for color
  let hash = 0;
  for (let i = 0; i < props.name.length; i++) {
    hash = props.name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 70%, 60%)`;
  return color;
});
const avatarStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  borderRadius: props.rounded ? "50%" : "4px",
  background: backgroundColor.value,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  fontSize: `${props.size * 0.5}px`,
  userSelect: "none",
}));
</script>

<style scoped>
.letter-avatar {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
</style>
